// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image-copyright{position:absolute;bottom:0;left:0;z-index:10;display:inline-block;background-color:rgba(0,0,0,.5);padding-left:.333rem;padding-right:.333rem;font-size:.6rem;--tw-text-opacity:1;color:rgba(255,255,255,var(--tw-text-opacity))}", ""]);
// Exports
module.exports = exports;
